import React, { Component } from "react";
import { HiExternalLink } from "react-icons/hi";
import sampleimage from './sampleimage.png';
import { IoMdArrowRoundBack } from "react-icons/io";
import { IoMdArrowRoundForward } from "react-icons/io";
import { CgSpinner } from "react-icons/cg";
import "./Auction.css";

class AuctionSkeleton extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    return (
      <div className="min-h-screen bg-custom-white dark:bg-custom-black">
        <div>
          <div className="ml-16 pt-20 flex">
            <div className="w-8 h-8 bg-gray-200 dark:bg-zinc-800 hover:bg-gray-300 duration-500 rounded-full cursor-pointer">
              <IoMdArrowRoundBack
                className="text-3xl dark:text-gray-400 text-gray-600"
                onClick={
                  () => window.location.href = window.location.origin + "/auctioncollections"
                }
              />
            </div>
            <div className="ml-2 text-xl font-semibold dark:text-white">
            </div>
          </div>
          <div className="text-md bg-gray-200 dark:bg-zinc-800 animate-pulse border-2 dark:border-zinc-800 rounded-md w-48 h-10 justify-center flex items-center ml-24 font-semibold text-gray-500 dark:text-zinc-500 mt-2" >
          </div>
          <div className="mt-4 w-screen justify-center flex">
            <div className="flex w-screen justify-center">
              <div className="flex-col flex md:flex-row h-auto md:h-128 items-center w-full xl:w-8/12 justify-around">
                <div className="h-auto md:h-128 justify-center flex flex-col">
                  <div className="w-80 h-80 sm:w-96 sm:h-96 mt-2 sm:mt-20 rounded-lg animate-pulse flex justify-center items-center">
                    <div className="w-80 h-80 sm:w-96 sm:h-96 rounded-lg dark:bg-zinc-800 bg-gray-200">
                    </div>
                  </div>
                  <div className="text-xl font-semibold mt-2 text-black dark:text-white">
                  </div>
                </div>
                <div className="h-112 flex flex-col justify-between">
                  <div className="sm:mt-0 mt-2 flex">
                    <div className="bg-gray-200 dark:bg-zinc-800 hover:bg-gray-300 duration-500 rounded-full cursor-pointer">
                    </div>
                    <div className="bg-gray-200 dark:bg-zinc-800 hover:bg-gray-300 duration-500 rounded-full ml-2 cursor-pointer">
                    </div>
                    <div className="text-gray-500 dark:text-zinc-500 ml-4 text-xl font-semibold">
                    </div>
                  </div>
                  <div className="h-8 w-60 animate-pulse dark:bg-zinc-800 bg-gray-200 rounded-sm">
                  </div>
                  <div className="flex">
                    <div>
                      <div className="text-2xl font-semibold text-gray-500 dark:text-zinc-500 mt-2">
                        Current bid
                      </div>
                      <div className="dark:bg-zinc-800 bg-gray-200 h-10 w-30 mt-2 animate-pulse rounded-sm">
                      </div>
                    </div>
                    <div className="ml-8">
                      <div className="text-2xl font-semibold text-gray-500 dark:text-zinc-500 mt-2">
                        Auction ends in
                      </div>
                      <div className="dark:bg-zinc-800 bg-gray-200 h-10 w-30 mt-2 animate-pulse">
                      </div>
                    </div>
                  </div>
                  <div className="flex mt-4">
                    <div className="animate-pulse p-2 w-60 sm:w-80 rounded-lg dark:bg-zinc-800 bg-gray-200 h-14 rounded-sm">
                    </div>
                    <div
                    className="cursor-pointer elative hover:-translate-y-0 hover:scale-105 duration-500 ml-2 w-20 sm:w-36 h-14 flex justify-center items-center text-lsm:text-xl font-bold bg-blue-600 rounded-lg text-white"
                      onClick={this.props.startFirstAuction}
                    >
                      {
                        this.props.hasClickedStartFirstAuction
                          ?
                        <CgSpinner size={40} className="loading-spinner" color="white" />
                          :
                        "Start 1st auction"
                      }
                    </div>
                  </div>
                  <div className="auctionBids">
                    <div className="w-80 mt-2 flex justify-between items-center">
                      <div className="h-6 w-60 animate-pulse dark:bg-zinc-800 bg-gray-200 rounded-sm">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {
          this.props.shouldShowSpinnerUntilFirstAuctionLoads
            ?
          <div className="text-2xl flex flex-col justify-center items-center font-semibold text-gray-500 dark:text-zinc-500 mt-4">
            Hang tight, your first item will be ready soon
            <CgSpinner size={40} className="loading-spinner mt-4" color="white" />
          </div>
            :
          null
        }
      </div>
    );
  }
}

export default AuctionSkeleton;
